module.exports = __webpack_public_path__ + "img/research-analyst.5770db0b.svg";